type ColVisibilityState = Record<string, boolean>;

const sharedVisible: ColVisibilityState = {
  farm_name: true,
  species__name: true,
  year: true,
  is_validated: true,
};

const metricsHidden: ColVisibilityState = {
  oleoze_tonnage: false,
  real_tonnage: false,
  tonnage_delta: false,
  tonnage_delta_percent: false,
  theoretical_area: false,
  calculated_area: false,
  area_delta: false,
  real_yield: false,
  recalculated_yield: false,
  yield_delta: false,
  agrest_yield: false,
  validated_at: false,
};

const baseColStates: ColVisibilityState = {
  ...sharedVisible,
  ...metricsHidden,
};

export const tonnagesColStates: ColVisibilityState = {
  ...baseColStates,
  oleoze_tonnage: true,
  real_tonnage: true,
  tonnage_delta: true,
  tonnage_delta_percent: true,
};

export const surfacesColStates: ColVisibilityState = {
  ...baseColStates,
  theoretical_area: true,
  calculated_area: true,
  area_delta: true,
};

export const rendementsColStates: ColVisibilityState = {
  ...baseColStates,
  real_yield: true,
  recalculated_yield: true,
  yield_delta: true,
  agrest_yield: true,
};
